import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ServicesPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4F3F1' }}>
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || mobileMenuOpen ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-[1400px] mx-auto px-5 md:px-12 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="https://public.readdy.ai/ai/img_res/431d0d82-5d35-4e5b-9098-9c3881ac0720.png" alt="Hair Salon Logo" className="h-10 md:h-12 w-auto object-contain" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-12">
            <Link to="/#home" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Home</Link>
            <Link to="/services" className="text-sm font-medium tracking-wider uppercase text-[#C9A961] transition-colors">Services</Link>
            <Link to="/#gallery" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Gallery</Link>
            <Link to="/#about" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">About</Link>
            <Link to="/#contact" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Contact</Link>
          </div>

          <a href="https://joshuastinnetthair.booksy.com/a/" target="_blank" rel="noopener noreferrer" className="hidden lg:flex bg-[#C9A961] text-white px-8 py-3 rounded-full text-sm font-medium tracking-wide uppercase hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer items-center gap-2">
            Book Now <i className="ri-arrow-right-line"></i>
          </a>

          {/* Mobile */}
          <div className="flex lg:hidden items-center gap-3">
            <a href="https://joshuastinnetthair.booksy.com/a/" target="_blank" rel="noopener noreferrer" className="bg-[#C9A961] text-white px-5 py-2 rounded-full text-xs font-medium tracking-wide uppercase whitespace-nowrap cursor-pointer">Book Now</a>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="w-10 h-10 flex items-center justify-center cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 px-5 py-6 flex flex-col gap-5">
            <Link to="/" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Home</Link>
            <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-[#C9A961]">Services</Link>
            <Link to="/#gallery" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Gallery</Link>
            <Link to="/#about" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">About</Link>
            <Link to="/media" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Press</Link>
            <Link to="/#contact" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Contact</Link>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="pt-20 md:pt-40 pb-6 md:pb-20 px-4 md:px-6 relative" style={{ backgroundColor: '#ECEAE6', backgroundImage: 'url(https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/22427efad05f543d534570106432bf64.png)', backgroundSize: '300px', backgroundRepeat: 'repeat' }}>
        <div className="absolute inset-0 bg-[#ECEAE6]/92"></div>
        <div className="max-w-[1200px] mx-auto text-center relative z-10">
          <div className="inline-block mb-2.5 md:mb-6 px-4 md:px-6 py-1.5 md:py-2 border border-gray-300 rounded-full">
            <span className="text-gray-600 text-[10px] md:text-xs font-medium tracking-widest uppercase">West Hollywood Private Studio</span>
          </div>
          <h1 className="text-xl md:text-6xl lg:text-7xl font-serif mb-2.5 md:mb-6 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Services &amp; Pricing
          </h1>
          <p className="text-gray-600 text-[11px] md:text-lg max-w-3xl mx-auto leading-relaxed">
            All prices and service times are starting points and may vary based on hair length, density, and desired result. Luxury private studio experience by appointment only.
          </p>
        </div>
      </section>

      {/* Color Services */}
      <section className="py-8 md:py-20 px-4 md:px-6" style={{ backgroundColor: '#F4F3F1' }}>
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-5 md:mb-16">
            <h2 className="text-lg md:text-4xl font-serif mb-2 md:mb-4 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Color Services</h2>
            <div className="w-10 md:w-16 h-0.5 md:h-1 bg-[#C9A961] mb-2 md:mb-6"></div>
            <p className="text-gray-600 leading-relaxed text-[11px] md:text-base">All color prices and service times are starting points and may vary based on hair length, density, and desired result.</p>
          </div>
          <div className="space-y-2 md:space-y-6">
            {[
              { name: 'New Client Color Consultation', price: '$50', time: '30 minutes', desc: 'Required for all new color and extension clients. Consultation fee may be credited toward your service if booked.' },
              { name: 'Balayage', price: 'Starting at $500', time: '3.5 hours', desc: '' },
              { name: 'Full Highlights', price: 'Starting at $500', time: '3.5 hours', desc: '' },
              { name: 'Partial Highlights', price: 'Starting at $250', time: '2.5 hours', desc: '' },
              { name: 'Double Process (Color + Highlights)', price: 'Starting at $600+', time: '4 hours', desc: '' },
              { name: 'Bleach & Tone', price: 'Starting at $300', time: 'Timing varies', desc: 'Timing depends on hair length, density, and desired level of lift. Consultation recommended.' },
              { name: 'All-Over Color', price: 'Starting at $250', time: '2 hours', desc: '' },
              { name: 'Root Touch-Up', price: '$200', time: '1.5 hours', desc: '' },
              { name: 'Hair Toner', price: '$80', time: '1 hour', desc: '' },
            ].map((item) => (
              <div key={item.name} className="rounded-xl md:rounded-2xl p-3.5 md:p-8 hover:shadow-lg transition-all" style={{ backgroundColor: '#ECEAE6' }}>
                <div className="flex flex-row justify-between items-start gap-2 mb-1 md:mb-2">
                  <h3 className="text-[11px] md:text-2xl font-semibold text-gray-900 leading-snug">{item.name}</h3>
                  <div className="text-right flex-shrink-0 ml-2">
                    <div className="text-[11px] md:text-2xl font-bold text-[#C9A961] whitespace-nowrap">{item.price}</div>
                    <div className="text-[10px] md:text-sm text-gray-500 whitespace-nowrap">{item.time}</div>
                  </div>
                </div>
                {item.desc && <p className="text-gray-600 leading-relaxed text-[11px] md:text-base">{item.desc}</p>}
              </div>
            ))}
            <div className="rounded-xl md:rounded-2xl p-3.5 md:p-8 hover:shadow-lg transition-all border border-[#C9A961] md:border-2" style={{ backgroundColor: '#ECEAE6' }}>
              <div className="flex flex-row justify-between items-start gap-2 mb-1 md:mb-2">
                <h3 className="text-[11px] md:text-2xl font-semibold text-gray-900">Color Correction</h3>
                <div className="text-right flex-shrink-0 ml-2">
                  <div className="text-[11px] md:text-2xl font-bold text-[#C9A961] whitespace-nowrap">Price varies</div>
                  <div className="text-[10px] md:text-sm text-gray-500 whitespace-nowrap">Consultation required</div>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed text-[11px] md:text-base">All corrective color services require a consultation prior to booking.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Haircuts */}
      <section className="py-8 md:py-20 px-4 md:px-6" style={{ backgroundColor: '#ECEAE6' }}>
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-5 md:mb-16">
            <h2 className="text-lg md:text-4xl font-serif mb-2 md:mb-4 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Haircuts</h2>
            <div className="w-10 md:w-16 h-0.5 md:h-1 bg-[#C9A961]"></div>
          </div>
          <div className="space-y-2 md:space-y-6">
            {[
              { name: "Women's Haircut", price: '$200', time: '1.5 hours' },
              { name: "Men's Haircut", price: '$90', time: '1 hour' },
              { name: 'Kids Haircut (12 & under)', price: '$80', time: '45 minutes' },
              { name: 'Barbering', price: '$90', time: '1 hour' },
            ].map((item) => (
              <div key={item.name} className="rounded-xl md:rounded-2xl p-3.5 md:p-8 hover:shadow-lg transition-all" style={{ backgroundColor: '#F4F3F1' }}>
                <div className="flex flex-row justify-between items-start gap-2">
                  <h3 className="text-[11px] md:text-2xl font-semibold text-gray-900">{item.name}</h3>
                  <div className="text-right flex-shrink-0 ml-2">
                    <div className="text-[11px] md:text-2xl font-bold text-[#C9A961] whitespace-nowrap">{item.price}</div>
                    <div className="text-[10px] md:text-sm text-gray-500 whitespace-nowrap">{item.time}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Styling & Grooming */}
      <section className="py-8 md:py-20 px-4 md:px-6" style={{ backgroundColor: '#F4F3F1' }}>
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-5 md:mb-16">
            <h2 className="text-lg md:text-4xl font-serif mb-2 md:mb-4 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Styling &amp; Grooming</h2>
            <div className="w-10 md:w-16 h-0.5 md:h-1 bg-[#C9A961]"></div>
          </div>
          <div className="space-y-2 md:space-y-6">
            {[
              { name: 'Blowout', price: '$100', time: '1 hour' },
              { name: 'Updos / Event Styling', price: '$250', time: '1.5 hours' },
              { name: "Men's Makeup / Grooming", price: '$100', time: '30 minutes' },
            ].map((item) => (
              <div key={item.name} className="rounded-xl md:rounded-2xl p-3.5 md:p-8 hover:shadow-lg transition-all" style={{ backgroundColor: '#ECEAE6' }}>
                <div className="flex flex-row justify-between items-start gap-2">
                  <h3 className="text-[11px] md:text-2xl font-semibold text-gray-900">{item.name}</h3>
                  <div className="text-right flex-shrink-0 ml-2">
                    <div className="text-[11px] md:text-2xl font-bold text-[#C9A961] whitespace-nowrap">{item.price}</div>
                    <div className="text-[10px] md:text-sm text-gray-500 whitespace-nowrap">{item.time}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hair Extensions */}
      <section className="py-8 md:py-20 px-4 md:px-6" style={{ backgroundColor: '#ECEAE6' }}>
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-5 md:mb-16">
            <h2 className="text-lg md:text-4xl font-serif mb-2 md:mb-4 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Hair Extensions</h2>
            <div className="w-10 md:w-16 h-0.5 md:h-1 bg-[#C9A961] mb-2 md:mb-6"></div>
            <p className="text-gray-600 leading-relaxed text-[11px] md:text-base">Consultation required for all extension services. I offer sew-in wefts, K-tips, I-tips, and tape-in extensions, with sew-in wefts being my specialty.</p>
          </div>
          <div className="space-y-2 md:space-y-6">
            <div className="rounded-xl md:rounded-2xl p-3.5 md:p-8 hover:shadow-lg transition-all" style={{ backgroundColor: '#F4F3F1' }}>
              <div className="flex flex-row justify-between items-start gap-2">
                <h3 className="text-[11px] md:text-2xl font-semibold text-gray-900">Extension Consultation</h3>
                <div className="text-right flex-shrink-0 ml-2">
                  <div className="text-[11px] md:text-2xl font-bold text-[#C9A961]">$50</div>
                  <div className="text-[10px] md:text-sm text-gray-500">30 minutes</div>
                </div>
              </div>
            </div>
            <div className="rounded-xl md:rounded-2xl p-3.5 md:p-8 hover:shadow-lg transition-all border border-[#C9A961] md:border-2" style={{ backgroundColor: '#F4F3F1' }}>
              <div className="flex flex-row justify-between items-start gap-2 mb-1.5 md:mb-3">
                <h3 className="text-[11px] md:text-2xl font-semibold text-gray-900">Hair Extensions Installation</h3>
                <div className="text-right flex-shrink-0 ml-2">
                  <div className="text-[11px] md:text-2xl font-bold text-[#C9A961] whitespace-nowrap">Starting at 2 hrs</div>
                  <div className="text-[10px] md:text-sm text-gray-500">Price varies</div>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed text-[11px] md:text-base">Timing and pricing depend on the extension method, number of wefts or rows, and hair provided. Final service length and pricing will be determined during consultation.</p>
            </div>
          </div>
        </div>
      </section>

      {/* On-Location */}
      <section className="py-8 md:py-20 px-4 md:px-6" style={{ backgroundColor: '#F4F3F1' }}>
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-5 md:mb-16">
            <h2 className="text-lg md:text-4xl font-serif mb-2 md:mb-4 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>On-Location / House Call Services</h2>
            <div className="w-10 md:w-16 h-0.5 md:h-1 bg-[#C9A961]"></div>
          </div>
          <div className="rounded-xl md:rounded-2xl p-4 md:p-10" style={{ backgroundColor: '#ECEAE6' }}>
            <div className="flex flex-row items-start gap-3 md:gap-6 mb-3 md:mb-6">
              <div className="w-9 h-9 md:w-14 md:h-14 rounded-full bg-[#C9A961] flex items-center justify-center flex-shrink-0">
                <i className="ri-car-line text-base md:text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-sm md:text-2xl font-semibold text-gray-900 mb-1.5 md:mb-4">Travel Services Available</h3>
                <div className="space-y-1 md:space-y-3 text-gray-600 leading-relaxed text-[11px] md:text-base">
                  <p>On-location appointments are available for select services.</p>
                  <p><strong className="text-gray-900">Flat travel fee starting at $250+</strong>, applied in addition to the cost of services.</p>
                  <p>Travel fees vary based on distance, parking, timing, and scope of work and will be confirmed prior to booking.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Policies */}
      <section className="py-8 md:py-20 px-4 md:px-6" style={{ backgroundColor: '#ECEAE6' }}>
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-5 md:mb-16">
            <h2 className="text-lg md:text-4xl font-serif mb-2 md:mb-4 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Booking Policies</h2>
            <div className="w-10 md:w-16 h-0.5 md:h-1 bg-[#C9A961]"></div>
          </div>
          <div className="rounded-xl md:rounded-2xl p-4 md:p-10" style={{ backgroundColor: '#F4F3F1' }}>
            <ul className="space-y-2.5 md:space-y-4 text-gray-700 leading-relaxed">
              {[
                'A credit card is required to book all appointments',
                'Deposits are required for all color, extension, and major services',
                'Deposits are applied toward the total service cost',
                'Cancellations made within 24 hours of the scheduled appointment will be charged 75% of the service total',
                'Late cancellations and no-shows will be charged accordingly',
                'Extended or multi-session appointments may be required for advanced services',
                'Luxury private studio experience by appointment only',
              ].map((policy) => (
                <li key={policy} className="flex items-start gap-2 md:gap-4">
                  <i className="ri-checkbox-circle-fill text-[#C9A961] text-sm md:text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-[11px] md:text-base">{policy}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-10 md:py-24 px-4 md:px-6 relative" style={{ backgroundColor: '#1A1A1A', backgroundImage: 'url(https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/22427efad05f543d534570106432bf64.png)', backgroundSize: '300px', backgroundRepeat: 'repeat' }}>
        <div className="absolute inset-0 bg-[#1A1A1A]/93"></div>
        <div className="max-w-[1000px] mx-auto text-center relative z-10">
          <h2 className="text-xl md:text-5xl font-serif mb-2.5 md:mb-6 text-white" style={{ fontFamily: 'Playfair Display, serif' }}>Ready to Book?</h2>
          <p className="text-gray-400 text-[11px] md:text-lg mb-5 md:mb-10 max-w-2xl mx-auto">Schedule your consultation or appointment today. Private studio sessions available in West Hollywood.</p>
          <a href="https://joshuastinnetthair.booksy.com/a/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#C9A961] text-white px-7 md:px-12 py-2.5 md:py-5 rounded-full text-xs md:text-sm font-medium tracking-wide uppercase hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer">
            Book Your Appointment
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-10 gap-10 md:gap-12 mb-10 md:mb-12">
            <div className="md:col-span-4">
              <Link to="/" className="flex items-center gap-3 mb-5 md:mb-6">
                <img src="https://public.readdy.ai/ai/img_res/431d0d82-5d35-4e5b-9098-9c3881ac0720.png" alt="Joshua Stinnett Hair Logo" className="h-10 w-auto object-contain" />
              </Link>
              <p className="text-gray-400 leading-relaxed mb-4 text-sm">Celebrity hairstylist and color specialist based in West Hollywood. Nearly two decades of experience in precision cutting, advanced blonding, and luxury client service.</p>
              <div className="mb-5 space-y-1">
                <a href="mailto:JoshuaStinnett85@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"><i className="ri-mail-line text-[#C9A961]"></i> JoshuaStinnett85@gmail.com</a>
                <a href="tel:3107708491" className="flex items-center gap-2 text-gray-400 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"><i className="ri-phone-line text-[#C9A961]"></i> 310.770.8491</a>
              </div>
              <div className="flex items-center gap-4">
                <a href="https://www.instagram.com/joshuastinnett?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer"><i className="ri-instagram-line"></i></a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer"><i className="ri-facebook-fill"></i></a>
                <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer"><i className="ri-pinterest-line"></i></a>
                <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer"><i className="ri-tiktok-line"></i></a>
              </div>
            </div>
            <div className="md:col-span-3">
              <h4 className="text-white text-sm font-medium tracking-widest uppercase mb-5">Quick Links</h4>
              <ul className="space-y-3">
                <li><Link to="/services" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Services</Link></li>
                <li><Link to="/#gallery" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Gallery</Link></li>
                <li><Link to="/#about" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">About Us</Link></li>
                <li><a href="https://joshuastinnetthair.booksy.com/a/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Booking</a></li>
                <li><Link to="/media" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Press</Link></li>
              </ul>
            </div>
            <div className="md:col-span-3">
              <h4 className="text-white text-sm font-medium tracking-widest uppercase mb-5">Stay Updated</h4>
              <p className="text-gray-400 mb-4 text-sm">Subscribe for styling tips and exclusive offers</p>
              <div className="flex gap-2">
                <input type="email" placeholder="Your email" className="flex-1 bg-[#2A2A2A] text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] placeholder-gray-500 text-sm min-w-0" />
                <button className="bg-[#C9A961] text-white px-5 py-3 rounded-lg hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer flex-shrink-0"><i className="ri-send-plane-fill"></i></button>
              </div>
              <p className="text-gray-500 text-xs mt-4">We respect your privacy</p>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center">© 2025 Joshua Stinnett. All rights reserved.</p>
            <div className="flex items-center gap-4 text-sm flex-wrap justify-center">
              <a href="#" className="text-gray-500 hover:text-[#C9A961] transition-colors cursor-pointer">Privacy Policy</a>
              <span className="text-gray-700">·</span>
              <a href="#" className="text-gray-500 hover:text-[#C9A961] transition-colors cursor-pointer">Terms</a>
              <span className="text-gray-700">·</span>
              <a href="#" className="text-gray-500 hover:text-[#C9A961] transition-colors cursor-pointer">Sitemap</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
